module.exports = __webpack_public_path__ + "static/img/3@2x.b2f66889.png";